
$('#message').hide();
$('#contestform').hide()
var url = 'https://script.google.com/macros/s/AKfycbzU4LE_WQwi3rOh6pWZvbani22Gjo2hNeQX6xCDEt2gr0qOgjD6wMdpv-cmRFX6WHM1/exec';

 $('#emailform').submit(function(e)
 {
  	e.preventDefault();
	var emailform = $('#emailform');
  	var emailquerystring = emailform.serialize();
    emailquerystring += "&fname=&lname=&storename=&position=&city=&state=&zip=&phone=&emailttt=&emailwest=&valid_ticket=TRUE";
   
	ajaxcall(url, emailquerystring); 
});
 
$("#contestform").submit(function(e) 
 {
  e.preventDefault();
  var form = $('#contestform');
  var querystring = form.serialize();
  //querystring = querystring.split("&emailttt")[0];
  querystring +="&valid_ticket=submit";
  querystring = "email=" + $('#email').val() + "&" + querystring;
  ajaxcall(url, querystring);
});

function ajaxcall(url, emailquerystring){
   $.ajax({
    url: url,
    contentType: 'text/plain;charset=utf-8',
    method: "GET",
    dataType: "json",
    data: emailquerystring,
    success: function( data ) 
    { 
      console.log(emailquerystring);
      var response = data;
      if(response.response == "show rest of form")
      {
        $('#contestform').show()    
        $('#submitbtnemail').hide()
      }
      
      else if(response.response == "submitted row data")
      {
        $('#message').text("First submission success! Go to the second showroom and scan the QR code there to complete your entry.");        
        $('#message').show();
        $('#emailform').hide();
        $('#contestform').hide();
      }
      
      else if(response.response == "final submission success")
      {
        $('#message').text("Nice! You've been entered into the random drawing. Stay tuned for the winner.");        
        $('#message').show();
        $('#emailform').hide();
        $('#contestform').hide();
      }
      
      else if (response.response == "user has already completed")
      {
        $('#message').text("You've already completed your entry. Stay tuned for the winner.");        
        $('#message').show();
      }

      console.log(JSON.stringify(response));
    },
    error: function(r) {console.log(r.statustext);}
  });
}
